import './box-user.scss';
import './import/user.svg';
